import { ComponentProps, useRef } from "react";
import { cn } from "../../../lib/utils";
import { Search } from "lucide-react";

export type TAppSearchInputProps = Omit<ComponentProps<"input">, "type"> & {
  isSquare?: boolean;
  classNameInput?: string;
};

export function AppSearchInput(props: TAppSearchInputProps) {
  const { className, classNameInput, isSquare, ...otherProps } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const shouldExpand = !isSquare || !!otherProps.value;

  const wrapperSizeClasses = cn(
    "w-full px-3",
    isSquare && !shouldExpand && "w-[32px] pl-[7px] hover:w-full hover:px-3 focus-within:w-full focus-within:px-3"
  );

  const inputSizeClasses = cn(
    "w-full ml-2",
    isSquare &&
      !shouldExpand &&
      "w-0 overflow-hidden group-hover:w-full group-hover:ml-2 group-focus-within:w-full group-focus-within:ml-2"
  );

  return (
    <div
      onClick={() => inputRef.current?.focus()}
      className={cn(
        "group flex items-center border border-innoveraZinc-150 rounded-[8px] h-[32px] transition-[width, padding] duration-300 ease",
        "hover:ring-2 hover:ring-innoveraZinc-150 focus-within:ring-2 focus-within:ring-innoveraZinc-150",
        wrapperSizeClasses,
        otherProps.disabled && "cursor-not-allowed opacity-50 pointer-events-none",
        className
      )}
      data-slot="input-wrapper"
    >
      <Search className="text-gray-500 w-4 h-4 min-w-4 min-h-4" />

      <input
        type="text"
        data-slot="input"
        ref={inputRef}
        className={cn(
          "placeholder:text-innoveraZinc-400 text-innoveraZinc-900 h-full bg-transparent text-[14px] leading-[22px] transition-[width, margin] duration-200 ease-in-out outline-none",
          inputSizeClasses,
          classNameInput
        )}
        {...otherProps}
      />
    </div>
  );
}
